import HeaderReservationManagement from "../../layouts/HeaderReservationManagement";
import Navbar from "../../layouts/Navbar";
import React from "react";
import RevenueArea from "../../features/dailyReport/RevenueArea";
import RevenueTherapist from "../../features/dailyReport/RevenueTherapist";
import RevenueIntroducer from "../../features/dailyReport/RevenueIntroducer";
import { useQuery } from "react-query";
import { getListNomination } from "../../api/nomination";
import RevenueStore from "../../features/dailyReport/RevenueStore";

function BasicInformationPage() {
  const { data: dataNominatation } = useQuery(
    ["list_nomination"],
    () => {
      return getListNomination({ per_page: 300 });
    },
    {
      staleTime: Infinity,
    }
  );

  return (
    <>
      <HeaderReservationManagement />
      <Navbar />
      <RevenueArea />
      <RevenueStore />
      <RevenueTherapist dataNominatation={dataNominatation?.data?.data || []} />
      <RevenueIntroducer />
    </>
  );
}

export default BasicInformationPage;
